import {CommonPage} from "./CommonPage";
import {PageHelper} from "./PageHelper";
import { ClaimInfoHeader } from "./ClaimInfoHeader";
import { NullClaimInfoHeader } from "./NullClaimInfoHeader";
import type { PageHeader } from "./PageHeader";
import type { SessionExpiry } from "./session/SessionExpiry";

export class NullCommonPage implements CommonPage {
    readonly ph: PageHelper = new PageHelper();
    readonly claimInfoHeader: ClaimInfoHeader = new NullClaimInfoHeader();
    readonly pageHeader: PageHeader = undefined;
    readonly sessionExpiry: SessionExpiry = undefined;
}
